import { TOKEN, REFRESH_TOKEN } from 'library/constants/auth';

const formatQueryParams = (query = {}) => {
  const q = {};

  Object.keys(query).forEach((key) => {
    // eslint-disable-next-line no-mixed-operators,max-len
    if ((query[key] || Number.isInteger(query[key])) && (!Array.isArray(query[key])) || query[key]?.length > 0 || query[key] === '') {
      q[key] = query[key];
    }
  });

  const params = new URLSearchParams(q);

  return params.toString();
};

async function waitUntil(condition) {
  return new Promise((resolve) => {
    const interval = setInterval((timestamp) => {
      if (condition()) {
        resolve();

        clearInterval(interval);
      } else if(Date.now() - timestamp > 10000) {
        localStorage.removeItem(TOKEN);
        localStorage.removeItem(REFRESH_TOKEN);

        window.location.replace(`${window.location.origin}/login`);
      }
    }, 1000, Date.now());
  });
}

// eslint-disable-next-line no-unused-vars
const fetchWithRetry = async (url, params, skipRetry = false) => {
  let result = await fetch(url, params);

  if (!result.ok) {
    if (result.status === 401 && !skipRetry) {
      const currentToken = localStorage.getItem(TOKEN);
      const currentRefreshToken = localStorage.getItem(REFRESH_TOKEN);

      try {
        if (currentRefreshToken) {
          localStorage.removeItem(REFRESH_TOKEN);

          const tokens = await fetch(`${process.env.REACT_APP_API_URL}/auth/refresh`, {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${currentToken}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ refreshToken: currentRefreshToken }),
          });
          const {
            token,
            refreshToken,
          } = await tokens.json();

          if(token && refreshToken) {
            localStorage.setItem(TOKEN, token);
            localStorage.setItem(REFRESH_TOKEN, refreshToken);
          } else {
            localStorage.removeItem(TOKEN);
            localStorage.removeItem(REFRESH_TOKEN);

            window.location.replace(`${window.location.origin}/login`);
          }
        } else {
          await waitUntil(() => Boolean(localStorage.getItem(REFRESH_TOKEN)));
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}

      result = await fetch(url, {
        ...params,
        headers: {
          ...params.headers,
          Authorization: `Bearer ${localStorage.getItem(TOKEN)}`,
        },
      });

      if (!result.ok) {
        localStorage.removeItem(TOKEN);
        localStorage.removeItem(REFRESH_TOKEN);

        window.location.replace(`${window.location.origin}/login`);
      }
    } else {
      const apiErrorBody = await result.json();

      throw new Error(apiErrorBody.message);
    }
  }

  return result;
};

// to be placed into request.js when mocked API isn't needed
export default async (url, method = 'GET', config = {}) => {
  const {
    query = {}, data, headers = {}, isFormData = false, skipRetry = false,
  } = config;
  const api = process.env.REACT_APP_API_URL;
  const requestParams = {
    method,
    headers: {
      ...headers,
      ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
      Authorization: `Bearer ${localStorage.getItem(TOKEN)}`,
      // mode: 'cors'
    },
  };

  if (['POST', 'PATCH'].includes(method)) {
    if (requestParams.headers['Content-Type'] === 'application/json') {
      requestParams.body = JSON.stringify(data);
    } else {
      requestParams.body = data;
    }
  }

  const queryParams = formatQueryParams(query);
  const requestUrl = queryParams ? `${api}${url}?${queryParams}` : `${api}${url}`;

  const result = await fetchWithRetry(requestUrl, requestParams, skipRetry);

  return result.json();
};
